import { ProductImagesUploader } from './ProductImagesUploader';

export { ProductImagesUploader };
